import React from 'react';
import { Form, Segment, Grid } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../../_utils/config';
import swal from 'sweetalert';

export default class FormAddVerificator extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         data: {
               username: "",
               password: "",
               alamat: "",
               nama: "",
               jabatan: "",
               kode: "",
               contact: "",
               institution: "",
            },

         loading: false,
         error: false,
      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
   }


   onSubmit(e){
      const { password, username, kode, nama, jabatan, alamat, institution } = this.state.data;
      this.setState({loading:true});
      e.preventDefault();
      if((password===null || password==="") || (username===null || username==="")){
         this.setState({loading: false, error: true});
         swal("", "Username dan password harus diisi", "error")
         return false;
      }else if(kode===null || kode===""){
            this.setState({loading: false, error: true});
            swal("", "NIP/Kode Pegawai harus diisi terlebih dahulu", "error")
            return false;
      }else if(nama===null || nama===""){
         this.setState({loading: false, error: true});
         swal("", "Nama Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(jabatan===null || jabatan===""){
         this.setState({loading: false, error: true});
         swal("", "Jabatan Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(alamat===null || alamat===""){
         this.setState({loading: false, error: true});
         swal("", "Alamat Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else{
         this.setState({ loading: true });
         e.preventDefault();
         fetch(`${BaseURLDev}/users/verificator`,{
            method: 'POST',
            headers,
            body: JSON.stringify(this.state.data)
         })
         .then(response => {
            if (!response.ok) { 
                  swal("", "Register user gagal", "error");
                  this.setState({loading:false,error:true});
                  return Promise.reject(response.statusText);
               }
            else{
               this.setState({
                  loading:false,
                  error:false,
                  data:{
                     "username": "",
                     "password": "",
                     "alamat": "",
                     "nama": "",
                     "jabatan": "",
                     "kode": "",
                     "contact": "",
                     "institution": "",
                  }
               });
            }
         })
      }
   }

   onCheckUserExits(username){
      fetch(`${BaseURLDev}/users/checkuser`, {
         headers,
         method: 'POST',
         body: JSON.stringify({
            "username": username
         })
      })
      .then(response => {
         if (!response.ok) { 
               return Promise.reject(response.statusText);
            }
         return response.json();
      })
      .then(resJSON => {
         return resJSON.status;
      })
      .catch(e => {
            swal("Check user error atau sedang terjadi gangguan di server", {
               icon: "error",
            });
      })
   }


   onChange(e){
      this.updateState([e.target.name],e.target.value);
   }
   updateState = (name,value) => this.setState({data:{...this.state.data, [name]:value}})
   

   render() {
      const {username, password, nama, jabatan, kode, alamat, contact, institution} = this.state.data;
      const {error,loading} = this.state;
      
      return (
         <Grid>         
            <Grid.Column width={8}>
               <Segment color='violet'>
                  <Form onSubmit={this.onSubmit} loading={loading}> 
                     
                     <Form.Group widths='equal'>
                        <Form.Input autoFocus error={error} value={username} onChange={this.onChange} placeholder="Username" name="username" />
                        <Form.Input error={error} type="password" value={password} onChange={this.onChange} placeholder="Password" name="password" />
                     </Form.Group>

                     <Form.Input value={kode} onChange={this.onChange} name="kode" placeholder="NIP/Kode Pegawai"/>
                     <Form.Input value={nama} onChange={this.onChange} name="nama" placeholder='Nama pegawai' />               
                     <Form.Input value={jabatan} onChange={this.onChange} name="jabatan" placeholder='Jabatan pegawai' />               
                     <Form.Input value={contact} onChange={this.onChange} name="contact" placeholder='Nomor contact' />               
                     <Form.Input value={institution} onChange={this.onChange} name="institution" placeholder='Nama institusi' />               
                     <Form.TextArea value={alamat} onChange={this.onChange} placeholder='Alamat pegawai' name="alamat" />
                     <Form.Button positive>Submit</Form.Button>
                  </Form>
               </Segment>
            </Grid.Column>
         </Grid>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/_userverificator/FormAddVerificator.js